import { Collapse } from "react-collapse";
import "./HelpContent.css";
import { assets } from "../../../publics/assets";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LanguageIcon from "@mui/icons-material/Language";
import PhoneIcon from "@mui/icons-material/Phone";

const HelpContent = ({ openSection, isSmallScreen }) => {
  const content = (
    <div className="help-container">
      <div className="help-section" data-testid="help-section-contact">
        <div className="help-section-title">Contact</div>
        <div className="help-contact-content">
          <div className="contact-text">
            <div className="custom-link" data-testid="help-contact-email" style={{ display: "flex", gap: "5px", alignItems: "center" }}>
              <EmailIcon style={{ fontSize: "18px" }} />
              <a href="mailto:contact@climate-innov.com">
                contact@climate-innov.com
              </a>
            </div>

            <div className="custom-link" data-testid="help-contact-linkedin" style={{ display: "flex", gap: "5px", alignItems: "center" }}>
              <LinkedInIcon style={{ fontSize: "18px" }} />
              <a href="https://www.linkedin.com/company/climate-innov/">
                Linkedin
              </a>
            </div>

            <div className="custom-link" data-testid="help-contact-website" style={{ display: "flex", gap: "5px", alignItems: "center" }}>
              <LanguageIcon style={{ fontSize: "18px" }} />
              <a href="https://www.climate-innov.com/" target="_blank" rel="noreferrer">
                Climate-Innov
              </a>
            </div>

            <div className="custom-link" data-testid="help-contact-phone" style={{ display: "flex", gap: "5px", alignItems: "center" }}>
              <PhoneIcon style={{ fontSize: "18px" }} />
              <a href="tel:+33617620416">+33 (6) 17 62 04 16</a>
            </div>
          </div>
        </div>
      </div>

      <div className="help-section" data-testid="help-section-guide">
        <div className="help-section-title">Guide utilisateur</div>
        <div className="help-section-content">
          <div className="userGuide-section-text">
            <p>Tout ce qu’il faut savoir, en un seul document.</p>
            <p>Cliquez pour télécharger le guide utilisateur dès maintenant.</p>
          </div>
          <div className="userGuide-section-image">
            <a href="/GuideUtilisateur_SecuFireAction.pdf" download data-testid="help-guide-download-link">
              <img src={assets.userGuide} style={{ width: "100%" }} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );

  return isSmallScreen ? (
    <Collapse isOpened={openSection === "help"}>
      {content}
    </Collapse>
  ) : (
    content
  );
};

export default HelpContent;
